import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Save `theme` for every project
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v7---')

  const projectsStore = transaction.objectStore('projects')

  // First, we get all projects
  const projectsRequest = projectsStore.getAll()
  projectsRequest.onsuccess = () => {
    const projects = projectsRequest.result
    STUDIO_ENV_DEVELOPMENT && console.log('Found all projects', projects)

    // Then, for each project, set the `theme` to `light`
    asyncForEach(
      projects,
      (project, next) => {
        STUDIO_ENV_DEVELOPMENT && console.log('Updating project', project)
        project.theme = 'light'
        STUDIO_ENV_DEVELOPMENT && console.log('Adding theme', project.tabOrder)
        projectsStore.put(project).onsuccess = next
      },
      () => {
        STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v7---')
        return next()
      }
    )
  }
}
